import { render } from "./AsideFavoriteChild.vue?vue&type=template&id=75226a9b&scoped=true"
import script from "./AsideFavoriteChild.vue?vue&type=script&lang=js"
export * from "./AsideFavoriteChild.vue?vue&type=script&lang=js"

import "./AsideFavoriteChild.vue?vue&type=style&index=0&id=75226a9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75226a9b"],['__file',"src/components/favorite/AsideFavoriteChild.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75226a9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75226a9b', __exports__)) {
    api.reload('75226a9b', __exports__)
  }
  
  module.hot.accept("./AsideFavoriteChild.vue?vue&type=template&id=75226a9b&scoped=true", () => {
    api.rerender('75226a9b', render)
  })

}


export default __exports__